import React from "react";
import { planTypes } from "utils/Types";
import { Comments } from "../Comments";
import CardDialogDetails from "./index";

const CommentsTab = React.memo(
  ({ sectionId, cardId, planId }: { planId?: string; sectionId?: string; cardId?: string }) => {
    if (!planId) return null;
    return <Comments sectionId={sectionId} cardId={cardId} planId={planId} />;
  }
);

export const getTabDetails = (planType: string | null, sectionId: any, cardId: any, planId: any) => {
  const commonTabs = [
    {
      label: "Info",
      content: CardDialogDetails
    }
  ];

  return planType === planTypes.AllPlans || planType === planTypes.MulipleAssign || planType === "TemplatePlan"
    ? [...commonTabs]
    : [
        ...commonTabs,
        {
          label: "Comments",
          content: () => <CommentsTab planId={planId} sectionId={sectionId} cardId={cardId} />
        }
      ];
};
